<template>
  <div id="dep_user_tree">
    <!-- 部门-员工树 -->
    <el-tree
      :data="data"
      :props="defaultProps"
      @node-click="handleNodeClick"
      node-key="id"
      show-checkbox
      @check="handleCheckChange"
      :default-checked-keys="userData"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <i class="iconfont icon-24gf-folderOpen" v-if="!node.isLeaf"></i>
        <i v-else class="iconfont icon-yonghu"></i>
        <span
          >{{ node.label
          }}<span v-if="data.isLeader == '0'" class="leader">
            <i class="el-icon-user-solid"></i></span
        ></span>
        <span class="perch-active"></span>
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "dep_user_tree",
  props: {
    treeData: {
      type: Array,
      defalut: function () {
        return [];
      },
    },
    checkData: {
      type: Array,
      defalut: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.treeData,
      userData: this.checkData,
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  watch: {
    treeData() {
      this.data = this.treeData;
    },
    data(newValue) {
      this.$emit("showTreeData", this.data);
    },
    checkData() {
      this.userData = this.checkData;
    },
    userData(newValue) {
      this.$emit("showCheckData", this.userData);
    },
  },
  methods: {
    handleNodeClick(data) {
      console.log("aaaa", data);
      this.$emit("handleNodeClick", data);
    },
    handleCheckChange(data, checked) {
      console.log(data, checked);
      this.$emit("handleCheckChange", checked);
    },
  },
};
</script>
<style lang="less" scoped>
#dep_user_tree {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  /deep/ .el-tree-node__content {
    height: 40px;
  }
  .custom-tree-node {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    i {
      margin-right: 5px;
    }
  }

  .leader {
    margin-left: 5px;
    color: #2695fd;
    font-size: 20px;
  }
}
</style>